import { Select, MenuItem, CircularProgress, FormControl, InputLabel, SelectChangeEvent } from "@mui/material";
import { useRecords } from "../../../api/useRecords";

type ServicesDropdownProps = {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    size?: "small" | "medium";
};

export const ServicesDropdown = ({ value, onChange, label = "Serviço", size = "small" }: ServicesDropdownProps) => {
    const { data, status: servicesStatus } = useRecords("services", "id,name,max_duration", {
        staleTime: Infinity,
        extraOptions: { sort: "sort_order", filter: { sort_order: { _nnull: true } } },
    });

    const handleChange = (event: SelectChangeEvent<string>) => {
        const selectedValue = event.target.value;
        onChange(selectedValue);
    };

    if (servicesStatus === "loading") return <CircularProgress size={20} />;
    if (servicesStatus === "error") return null;

    return (
        <FormControl fullWidth size={size}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value}
                onChange={handleChange}
                label={label}
                MenuProps={{ disablePortal: true }}
            >
                <MenuItem value="">
                    <em>Todos os serviços</em>
                </MenuItem>
                {data?.items.map((service: any) => (
                    <MenuItem key={service.id} value={service.id}>
                        {service.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

